import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { actions } from './wizard.slice'
import { Button } from '@/components/ui/button'
import {
	selectCurrentStep,
	selectIsCurrentPageValid,
	selectIsFflNumberValid,
	selectIsReplaceable,
	selectWizardFormValues,
} from './wizard.selectors'
import Modal from '../modal'
import Stepper from '../CustomStepper'
import { isEmpty } from 'lodash'
import BusyIndicator from '../busyIndicator'

const {
	resetCurrentStep,
	nextClicked,
	backClicked,
	resetFormValues,
	setIsCurrentPageValid,
	setFormValues,
	setIsReplaceable,
	setIsFflNumberValid,
	setIsCheckboxChecked,
} = actions

const Wizard = ({
	title,
	onCancel,
	onFinalize,
	pages,
	finalButtonText = 'Create Customer',
	initialFormData = {},
	onClose,
	replaceablePage,
	utilityClass = '',
	haveLessTopMargin,
	region,
	shouldDisabledButton = false,
	errorMessage,
}) => {
	const dispatch = useDispatch()
	const currentStep = useSelector(selectCurrentStep)
	const wizardForm = useSelector(selectWizardFormValues)
	const isCurrentPageValid = useSelector(selectIsCurrentPageValid)
	const isReplaceable = useSelector(selectIsReplaceable)
	const isFflNumberValid = useSelector(selectIsFflNumberValid)

	useEffect(() => {
		if (!isEmpty(initialFormData) && isEmpty(wizardForm)) {
			dispatch(setFormValues(initialFormData))
		}
	}, [initialFormData, dispatch, wizardForm])

	const navigateToNextPage = () => {
		dispatch(setIsReplaceable(false))
		dispatch(nextClicked())
		dispatch(setIsCurrentPageValid(false))
	}

	const navigateToPrevious = () => {
		dispatch(setIsReplaceable(false))
		dispatch(backClicked())
	}

	const resetWizard = () => {
		dispatch(resetCurrentStep())
		dispatch(resetFormValues())
		dispatch(setIsCurrentPageValid(false))
	}

	const finalize = () => {
		onFinalize(wizardForm, resetWizard)
	}
	const resetModal = () => {
		onCancel()
		resetWizard()
		dispatch(setIsFflNumberValid(false))
		dispatch(setIsCheckboxChecked(false))
	}

	const CurrentPage = isReplaceable
		? replaceablePage.component
		: pages[currentStep].component

	const CurrentPageSize = !isEmpty(pages[currentStep].size)
		? pages[currentStep].size
		: 'sm'

	const isFinalPage = pages.length === currentStep + 1
    const footer = (
        <div className='flex items-center justify-between gap-2'>
            <div>
                {!isFinalPage && !currentStep ? (
                    <Button variant='outline' onClick={resetModal} className={utilityClass && isFinalPage ? `mr-2 ${utilityClass}` : 'mr-2'}>
                        {'Cancel'}
                    </Button>
                ) : (
                    <Button variant='outline' onClick={navigateToPrevious}>Back</Button>
                )}
            </div>
            <div>
                {isFinalPage && currentStep ? (
                    <Button
                        variant={isCurrentPageValid ? 'default' : 'secondary'}
                        onClick={finalize}
                        disabled={!isCurrentPageValid || shouldDisabledButton || !isFflNumberValid}
                        className={utilityClass && isFinalPage ? `mr-2 ${utilityClass}` : 'mr-2'}
                    >
                        <BusyIndicator region={region}>{finalButtonText}</BusyIndicator>
                    </Button>
                ) : (
                    <Button onClick={navigateToNextPage} disabled={!isCurrentPageValid}>Next</Button>
                )}
            </div>
        </div>
    )

	return (
		<Modal
			title={title}
			reset={resetModal}
			footer={footer}
			onClose={onClose}
			size={CurrentPageSize}
			haveLessTopMargin={haveLessTopMargin}
		>
			<Stepper activeSteps={currentStep} />
			{!isEmpty(errorMessage) && (
				<div className='error-message mb-10'>{errorMessage}</div>
			)}
			<div>
				<CurrentPage
					wizardForm={wizardForm}
					currentStep={currentStep}
					finalize={finalize}
					cancel={resetModal}
				/>
			</div>
		</Modal>
	)
}
export default Wizard
